import React from 'react'
import "./Education.css";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaSchool } from 'react-icons/fa';
import { MdSchool } from 'react-icons/md';
import { FaBook } from 'react-icons/fa';

const Education = () => {
  return (
    <>
      <div className='edu-conatiner'>
        <div className='myeducation'>
          <p className='education'>Education</p>
        </div>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(155, 72, 215)', color: '#2f3c45' }}
            contentArrowStyle={{ borderRight: '9px solid  rgb(155, 72, 215)' }}
            date="2019 - 2023"
            iconStyle={{ background: 'rgb(155, 72, 215)', color: '#2f3c45' }}
            icon={<MdSchool />}
          >
            <h3 className="vertical-timeline-element-title">Atria Institute of Technology</h3>
            <h4 className="vertical-timeline-element-subtitle">Bangalore, KA, India</h4>
            <p>
              B.E: Computer Science & Engineering<br /> CGPA: 7.57/10
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(155, 72, 215)', color: ' #2f3c45' }}
            contentArrowStyle={{ borderRight: '9px solid rgb(155, 72, 215)' }}
            date="2017 - 2019"
            iconStyle={{ background: 'rgb(155, 72, 215)', color: ' #2f3c45' }}
            icon={<FaSchool />}
          >
            <h3 className="vertical-timeline-element-title">Kendriya Vidyalaya No.1</h3>
            <h4 className="vertical-timeline-element-subtitle">Port Blair, A&N-744101, India</h4>
            <p>
              12th Standard(PCMB)<br />Percentage: 71%
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(155, 72, 215)', color: ' #2f3c45' }}
            contentArrowStyle={{ borderRight: '9px solid  rgb(155, 72, 215)' }}
            date="2016- 2017"
            iconStyle={{ background: 'rgb(155, 72, 215)', color: ' #2f3c45' }}
            icon={<FaBook />}
          >
            <h3 className="vertical-timeline-element-title">Kendriya Vidyalaya No.1</h3>
            <h4 className="vertical-timeline-element-subtitle">Port Blair, A&N-744101, India</h4>
            <p>
              10th Standard<br />CGPA: 8.2
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </>
  )
}

export default Education